import { createAsyncThunk } from '@reduxjs/toolkit'
import { Payload } from 'stores'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import {
  STORE_BILL_PREVIEW_LINE_ITEM,
  STORE_BILL_PREVIEW_LINE_ITEM_FETCH,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { ErrorStore, LineItemsV2 } from '@types'

type State = GenericState<LineItemsV2[]>

export const initialState: State = {
  data: [],
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchPreviewLineItem = createAsyncThunk<
  LineItemsV2[],
  Promise<LineItemsV2[]>,
  Payload
>(STORE_BILL_PREVIEW_LINE_ITEM_FETCH, async (promise, { rejectWithValue }) => {
  try {
    return await promise
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  LineItemsV2[],
  LineItemsV2[],
  Payload
>(fetchPreviewLineItem, initialState.data)

const slice = createGenericSlice({
  name: STORE_BILL_PREVIEW_LINE_ITEM,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear, success } = actions

export { clear, success }

export default reducer
